export const TBL_SUBSCRIPTIONS = 'Subscriptions';
export const TBL_SUBSCRIPTION_ATTACHMENTS = 'SubscriptionAttachments';

export const TBL_LOAN_REQUESTS = 'LoanRequests';
export const TBL_LOAN_REQUEST_ATTACHMENTS = 'LoanRequestAttachments';

export const TBL_INFOSHEETS = 'Infosheets';
export const TBL_USERS = 'Users';
